/// <reference path='../userDefinedControls.module.ts' />
/// <reference path='../../../../../typings/index.d.ts' />

module Meevo.Plugins.UserDefinedControls {

    import customControlsModel = Meevo.Components.BaseClasses.ICustomControlsModel;
    import AppAreaEnum = Meevo.Model.AppAreaEnum;
    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import IAppAreaTab = Meevo.Model.IAppAreaTab;
    import IBusinessType = Meevo.Model.IBusinessType;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import IUserDefinedControlValue = Meevo.Model.IUserDefinedControlValue;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import UserDefinedControlsService = Meevo.Plugins.UserDefinedControls.IUserDefinedControlsService;
    import IPromise = Q.IPromise;
    import IAppAreaService = Meevo.Model.IAppAreaService;

    interface IMultipleServiceParams {
        selectedService: IAppAreaService,
        services: IAppAreaService[]
    }

    export class AddControlModalController {
        public controlTypes: Object;
        public userDefinedControl: IUserDefinedControl;
        public showControlForm: boolean = false;
        public showValuesEditor: boolean = false;
        public isActive: boolean = false;
        public isHiddenFromReports: boolean = true;
        public minDate: Date = new Date();
        public prefixRegExp: RegExp = new RegExp('^[a-zA-Z0-9]{2,10}$');
        public selectedControlType: number;
        public modalTitle: string;
        public modalSaveButtonTitle: string;
        public isEditing: boolean;
        public isCopying: boolean;
        public ableToChangeTab: boolean = false;
        public tabList: Array<IAppAreaTab> = [];
        public currentTabId: Guid = null;
        public userDefinedControlDeletedValues: Array<IUserDefinedControlValue> = [];
        public isAssignedServicesTemplate: boolean = false;
        public serviceLabel: string = 'LABEL_SERVICE_NAME';
        public multipleServiceParams: IMultipleServiceParams = {
            selectedService: null,
            services: []
        };
        public servicesSearchCriteria: Object;
        public isServicesAttached: boolean = this.userDefinedControl && [AppAreaEnum.Booking, AppAreaEnum.Checkin, AppAreaEnum.Checkout].indexOf(this.userDefinedControl.appAreaEnum) !== -1;

        private customControlsModel: customControlsModel;
        private _unsupportedUDFTypesForBooking: Object = {
            [ControlTypeEnum.DropDown]: 0,
            [ControlTypeEnum.Radio]: 1,
            [ControlTypeEnum.DatePicker]: 2,
            [ControlTypeEnum.ImageUpload]: 3,
            [ControlTypeEnum.DocumentUpload]: 4
        };
        private businessTypes: IBusinessType[];

        /**
         * Checking for unsupported control
         * @returns {boolean}
         */
        public isUnsupportedUDF(): boolean {
            return this.userDefinedControl.controlTypeEnum in this._unsupportedUDFTypesForBooking;
        }

        public get isCheckoutArea(): boolean {
            return this.userDefinedControl.appAreaEnum === AppAreaEnum.Checkout;
        }

        static $inject = [
            '$mdDialog',
            'meevo.plugins.userDefinedControls.userDefinedControlsService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService'
        ];

        constructor(
            protected $mdDialog: ng.material.IDialogService,
            protected userDefinedControlsService: Meevo.Plugins.UserDefinedControls.IUserDefinedControlsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService
        ) {
            this.controlTypes = this.userDefinedControlsService.controlTypes;
            this.isHiddenFromReports = true;

            // check if we are editing UDF
            if (this.userDefinedControl && this.userDefinedControl.controlName) {
                this.initEditMode();
            }
            else if (this.userDefinedControl && !this.userDefinedControl.controlName) {
                this.initCopyMode();
            } else {
                this.userDefinedControl = <IUserDefinedControl>{
                    controlName: '',
                    displayName: '',
                    controlTypeEnum: ControlTypeEnum.DropDown,
                    appAreaEnum: AppAreaEnum.None,
                    objectStateEnum: ObjectStateEnum.Inactive,
                    shortcut: '',
                    isRequired: false,
                    items: [{
                        displayName: '',
                        sortOrder: 0,
                        isDefault: true,
                        isDefaultCopy: true,
                        objectStateEnum: ObjectStateEnum.Active
                    }],
                    fileGuid: null,
                    customDataControlResourceObject: {}
                };
            }

            this.modalTitle = this.isEditing ? 'LABEL_EDIT_FIELD' : this.isCopying ? 'LABEL_COPY_FIELD' : 'LABEL_ADD_NEW_FIELD';
            this.modalSaveButtonTitle = this.isEditing || this.isCopying ? 'LABEL_SAVE' : 'LABEL_SAVE_NEW_FIELD';

            this.createNewControl();
        }

        /**
         * Initialize edit mode
         */
        public initEditMode(): IPromise<void> {
            this.isEditing = true;
            this.showControlForm = true;

            if (AddControlModalController.isFormType1(this.userDefinedControl.controlTypeEnum)) {
                this.showValuesEditor = true;
            }
            this.selectedControlType = this.userDefinedControl.controlTypeEnum;
            this.isHiddenFromReports = !this.userDefinedControl.isSearchable;

            this.busyService.start();
            return this.getBusinessTypes()
                .then(() => this.dataService.getItem('CustomData/Control', this.userDefinedControl.control_TId))
                .then((control: IUserDefinedControl | any) => {
                    if (control.controlServices && !!control.controlServices.length) {
                        this.multipleServiceParams.services = control.controlServices.map((service) => {
                            return {
                                id: service.service_TId,
                                shortcut: service.controlServiceShortCut,
                                displayName: service.controlServiceName
                            }
                        })
                        this.servicesSearchCriteria = {
                            'ExcludeIdList': this.multipleServiceParams.services.map(service => service.id) || []
                        };
                    }

                    this.userDefinedControl = control;
                    this.isActive = this.userDefinedControl.objectStateEnum == ObjectStateEnum.Active;

                    // find default value and make copy of it
                    if (this.userDefinedControl.items.length) {
                        let defaultItem: IUserDefinedControlValue = _.find(this.userDefinedControl.items, item => item.isDefault);

                        if (defaultItem) {
                            defaultItem.isDefaultCopy = true;
                        }
                    }

                    if (this.userDefinedControl.appAreaEnum !== AppAreaEnum.None && this.userDefinedControl.tab_TId) {
                        let businessType_TId: Guid = this.userDefinedControl.businessType_TId;

                        businessType_TId = businessType_TId ? businessType_TId : null;

                        this.currentTabId = this.userDefinedControl.tab_TId;
                        this.ableToChangeTab = this.businessTypes.length > 1;

                        return this.dataService.getListPaged('CustomData/Tab', {
                            criteria: {
                                appAreaEnum: this.userDefinedControl.appAreaEnum,
                                businessType_TId,
                                includeControls: true,
                                isReAssign: true
                            }
                        })
                            .then((data: any) => {
                                this.tabList = data[this.userDefinedControl.appAreaEnum];
                            })
                            .finally(() => this.busyService.stop());
                    } else {
                        this.busyService.stop();
                    }
                })
                .catch(() => this.busyService.stop());
        }

        public initCopyMode(): IPromise<void> {
            this.isCopying = true;
            this.showControlForm = true;
            console.log(this.userDefinedControl);

            let currentTab_TId = this.userDefinedControl.tab_TId;

            this.busyService.start();
            return this.getBusinessTypes()
                .then(() => this.dataService.getItem('CustomData/Control', this.userDefinedControl.control_TId))
                .then((control: IUserDefinedControl | any) => {
                    if (control.controlServices && !!control.controlServices.length) {
                        this.multipleServiceParams.services = control.controlServices.map((service) => {
                            return {
                                id: service.service_TId,
                                shortcut: service.controlServiceShortCut,
                                displayName: service.controlServiceName
                            }
                        })
                        this.servicesSearchCriteria = {
                            'ExcludeIdList': this.multipleServiceParams.services.map(service => service.id) || []
                        };
                    }

                    this.userDefinedControl = control;

                    // copied controls belong to the current tab_TId, not the original tab_TId
                    if (this.userDefinedControl.tab_TId !== currentTab_TId) {
                        this.userDefinedControl.tab_TId = currentTab_TId;
                    }

                    console.log(this.userDefinedControl);
                    this.userDefinedControl.control_TId = null;
                    this.userDefinedControl.controlName = null;
                    this.userDefinedControl.shortcut = null;
                    this.userDefinedControl.entityVersion = null;
                    this.userDefinedControl.items.forEach(item => { item.item_TId = null, item.control_TId = null });

                    this.selectedControlType = this.userDefinedControl.controlTypeEnum;
                    this.isHiddenFromReports = !this.userDefinedControl.isSearchable;

                    if (AddControlModalController.isFormType1(this.userDefinedControl.controlTypeEnum)) {
                        this.showValuesEditor = true;
                    }

                    this.isActive = this.userDefinedControl.objectStateEnum == ObjectStateEnum.Active;

                    // find default value and make copy of it
                    if (this.userDefinedControl.items.length) {
                        let defaultItem: IUserDefinedControlValue = _.find(this.userDefinedControl.items, item => item.isDefault);

                        if (defaultItem) {
                            defaultItem.isDefaultCopy = true;
                        }
                    }
                    
                    if (this.userDefinedControl.appAreaEnum !== AppAreaEnum.None && this.userDefinedControl.tab_TId) {
                        let businessType_TId: Guid = this.userDefinedControl.businessType_TId;

                        businessType_TId = businessType_TId ? businessType_TId : null;

                        this.currentTabId = this.userDefinedControl.tab_TId;
                        this.ableToChangeTab = this.businessTypes.length > 1;

                        return this.dataService.getListPaged('CustomData/Tab', {
                            criteria: {
                                appAreaEnum: this.userDefinedControl.appAreaEnum,
                                businessType_TId,
                                includeControls: true,
                                isReAssign: true
                            }
                        })
                            .then((data: any) => {
                                this.tabList = data[this.userDefinedControl.appAreaEnum];
                            })
                            .finally(() => this.busyService.stop());
                    } else {
                        this.busyService.stop();
                    }
                })
                .catch(() => this.busyService.stop());
        }

        /**
         * Close modal window
         * */
        public closeModal(): void {
            this.$mdDialog.cancel();
        };

        /**
         * Create New Control
         * */
        public createNewControl(): void {
            let isFormType1 = AddControlModalController.isFormType1(this.userDefinedControl.controlTypeEnum);
            // save selected control type
            this.selectedControlType = this.userDefinedControl.controlTypeEnum;

            this.showControlForm = true;
            angular.extend(this.userDefinedControl, {
                controlName: '',
                displayName: '',
                shortcut: '',
                items: [{
                    displayName: '',
                    sortOrder: 0,
                    isDefault: this.userDefinedControl.isRequired,
                    isDefaultCopy: !this.userDefinedControl.isRequired,
                    objectStateEnum: ObjectStateEnum.Active
                }]
            });
            this.isActive = false;

            if (isFormType1) {
                this.showValuesEditor = true;
            } else {
                this.userDefinedControl.items = [];
                this.showValuesEditor = false;
            }

            // sets autofocus after user selects dropdown option
            window.setTimeout(() => { // need the timeout to push the UI thread up the stack so the field is made active before trying to set focus
                angular.element('#udcInput #LABEL_NAME')[0] && angular.element('#udcInput #LABEL_NAME')[0].focus();
            }, 500);
        }

        /**
         * Add new value
         * */
        public addValueField(): void {
            this.userDefinedControl.items.push(<IUserDefinedControlValue>{
                displayName: '',
                sortOrder: 0,
                isDefault: false,
                isDefaultCopy: false,
                objectStateEnum: ObjectStateEnum.Active
            });
        }

        /**
         * Remove value field
         * */
        public removeValueField(item: IUserDefinedControlValue): void {
            let index = this.userDefinedControl.items.indexOf(item);

            this.userDefinedControl.items.splice(index, 1);
            if (item['control_TId']) {
                item.objectStateEnum = ObjectStateEnum.Deleted;
                item.sortOrder = -1;
                this.userDefinedControlDeletedValues.push(item);
            }
        }

        /**
         * Activate/Deactivate value field
         * */
        public changeValueFieldState(item: IUserDefinedControlValue, state: ObjectStateEnum): void {
            item.objectStateEnum = state;
        }

        /**
         * Reorder values
         * @param {IUserDefinedControlValue} item
         * @param {number} direction - available values 1, -1
         * */
        public moveItem(item: IUserDefinedControlValue, direction: number): void {
            let index = this.userDefinedControl.items.indexOf(item);

            UserDefinedControlsService.moveItem(this.userDefinedControl.items, index, index + direction);
        }

        /**
         * check if form is valid
         */
        public checkIfValid(isFormValid: boolean): void {
            if (isFormValid) {
                this.modalService.alert("MESSAGE_COMPLETE_ALL_FIELDS_THAT_REQUIRE_ATTENTION", 0, true);
                return;
            }

            if (this.isCheckoutArea && this.userDefinedControl.isRequired) {
                this.modalService.alert('MESSAGE_UDF_ASSIGN_TO_CHECKOUT_ERROR', Meevo.Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            if (AddControlModalController.isFormType1(this.selectedControlType)) {
                if (this.checkItemsValidity()) {
                    this.saveField();
                }
            } else {
                this.saveField();
            }
        }

        /**
         * Check items validity
         * */
        protected checkItemsValidity(showMultiple = false): boolean {
            let itemsValid: boolean = true,
                len = this.userDefinedControl.items.length,
                itemsValueDictionary = {};

            // check values uniqueness
            for (let i = 0; i < len; i++) {
                let item = this.userDefinedControl.items[i];

                if (typeof itemsValueDictionary[item.displayName] === 'undefined') {
                    itemsValueDictionary[item.displayName] = true;
                } else {
                    itemsValid = false;

                    this.modalService
                        .alert('MESSAGE_UNIQUE_VALUES', Meevo.Components.Modal.ModalTranslationModes.Translate, showMultiple);
                    break;
                }
            }

            if (itemsValid) {
                // At least one item should be active
                let areAllItemsInactive = this.userDefinedControl.items.every((item: IUserDefinedControlValue) => {
                    return item.objectStateEnum === ObjectStateEnum.Inactive
                });

                if (areAllItemsInactive) {
                    itemsValid = false;

                    this.modalService
                        .alert('MESSAGE_AT_LEAST_ONE_ITEM_SHOULD_BE_ACTIVE', Meevo.Components.Modal.ModalTranslationModes.Translate, showMultiple);
                }
            }

            return itemsValid;
        }

        /**
         * Save UDF
         * */
        protected saveField(): ng.IPromise<void> {
            let data: IUserDefinedControl;

            this.userDefinedControl.objectStateEnum = this.isActive ? ObjectStateEnum.Active : ObjectStateEnum.Inactive;
            this.userDefinedControl.controlTypeEnum = this.selectedControlType;

            /**
             * on the backend side we have parameter - isSearchable
             * on the frontend side we have checkbox that says - 'Hide from reports'
             * 'searchable' is opposite for 'hide from reports'
             * so we need to do next manipulation
             */
            this.userDefinedControl.isSearchable = !this.isHiddenFromReports;
            this.userDefinedControl.serviceListIds = this.multipleServiceParams.services.map(service => service.id) || [];

            this.userDefinedControl.items.map((item, index) => {
                item['sortOrder'] = index;
            });

            data = angular.copy(this.userDefinedControl);

            if (this.isEditing && this.userDefinedControlDeletedValues.length) {
                data.items = data.items.concat(this.userDefinedControlDeletedValues);
            }

            if (this.ableToChangeTab) {
                if (data.tab_TId !== this.currentTabId) {
                    let tab = _.findWhere(this.tabList, { tab_TId: this.currentTabId });

                    data.tab_TId = tab.tab_TId;
                    data.isMainTab = tab.isMain;
                    data.tabName = tab.displayName;

                    if (tab.controls.length === 0) {
                        data.sortOrder = 0;
                    } else {
                        // get control with highest sortOrder, add 1
                        data.sortOrder = tab.controls[tab.controls.length - 1].sortOrder + 1;
                    }
                }
            }

            this.busyService.start();
            return this.dataService.add('CustomData/Control', data)
                .then((response: IUserDefinedControl | any) => {
                    if (response['isWarning']) {
                        this.modalService
                            .alert(response.responseStatus.message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate, true);
                    } else {
                        this.$mdDialog.hide(response);
                    }
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Required state is changed
         */
        public requiredStateToggled(): void {
            if (this.userDefinedControl.isRequired) {
                if (this.ableToChangeTab) {
                    // set main tab selected
                    this.currentTabId = _.find(this.tabList, tab => tab.isMain).tab_TId;
                }

                // reset values for isDefault
                this.userDefinedControl.items.map(item => {
                    item.isDefault = false;
                });
            } else {
                let defaultItem: IUserDefinedControlValue = _.find(this.userDefinedControl.items, item => item.isDefaultCopy);

                if (this.ableToChangeTab) {
                    // set UDF's tab selected
                    this.currentTabId = this.userDefinedControl.tab_TId
                }

                // set isDefault as it was before resetting
                if (defaultItem) {
                    defaultItem.isDefault = true;
                }
            }
        }

        /**
         * Ability to check only one checkbox from list (emulate radio buttons)
         * @param {IUserDefinedControlValue} value
         */
        public changeIsDefault(value: IUserDefinedControlValue): void {
            value.isDefaultCopy = value.isDefault;

            this.userDefinedControl.items.map((item) => {
                if (item !== value) {
                    item.isDefault = false;
                    item.isDefaultCopy = false;
                }
            });
        }

        /**
         * Check if the type of shown form is first
         * @param {ControlTypeEnum} controlType
         * @returns {boolean} is form type 1 is active
         * */
        static isFormType1(controlType: ControlTypeEnum): boolean {
            let isFormType1: boolean = false;

            // just not to write long 'if' statement
            switch (Number(controlType)) { // from html comes string
                case ControlTypeEnum.DropDown:
                case ControlTypeEnum.Radio:
                case ControlTypeEnum.ListBox:
                case ControlTypeEnum.CheckBox:
                    isFormType1 = true;
                    break;
            }

            return isFormType1;
        }

        private getBusinessTypes() {
            return this.dataService.getListPaged('userbusinesstype', {
                    pageNumber: 0,
                    itemsPerPage: 100
                })
                .then((data: Array<IBusinessType> | any) => {
                    data.forEach((item: IBusinessType) => {
                        if (item.id === '00000000-0000-0000-0000-000000000001') {
                            item.id = null;
                        }
                    });

                    this.businessTypes = data;
                });
        }

        /**
         * Run preview modal
         * */
        previewField(): void {
            let previewData: IUserDefinedControl = angular.copy(this.userDefinedControl);

            previewData.items.forEach((item: IUserDefinedControlValue, index) => {
                item.sortOrder = index;
                item.item_TId = item.item_TId || item.displayName;
                item.control_TId = item.control_TId || item.displayName;
            });
            previewData['answers'] = [];

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/userDefinedControls/add/preview.modal.html',
                controller: 'meevo.plugins.userDefinedControls.AddControlModalController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                preserveScope: true,
                skipHide: true,
                multiple: true,
                locals: {
                    fields: [previewData]
                }
            };

            this.modalService.showCustom(options);
        };

        get objectStateEnum(): any {
            return ObjectStateEnum;
        }

        get controlTypeEnum(): any {
            return ControlTypeEnum;
        }

        get appAreaEnum(): any {
            return AppAreaEnum;
        }

        public openAssignedServicesTemplate(): void {
            this.isAssignedServicesTemplate = true;
        }

        public openFieldAttributesTemplate(): void {
            this.isAssignedServicesTemplate = false;
        }

        public changedSelectedService(service: IAppAreaService): void {
            if  (service) {
                this.multipleServiceParams.services.push(service);

                // Changing criteria service list
                this.servicesSearchCriteria = {
                    'ExcludeIdList': this.multipleServiceParams.services.map(service => service.id) || []
                };
            }
            this.multipleServiceParams.selectedService = null;

            this.changingServiceName();
        }

        changingServiceName(): void {
            this.serviceLabel = this.multipleServiceParams.services.length > 1 ? 'LABEL_MULTIPLE_NAME' : 'LABEL_SERVICE_NAME';
        }

        public removeService(item: IAppAreaService): void {
            let index = this.multipleServiceParams.services.indexOf(item);
            this.multipleServiceParams.services.splice(index, 1);
            this.servicesSearchCriteria = {
                'ExcludeIdList': this.multipleServiceParams.services.map(service => service.id) || []
            };

            this.changingServiceName();
        }
    }

    angular.module('meevo.plugins.userDefinedControls')
        .controller('meevo.plugins.userDefinedControls.AddControlModalController', AddControlModalController);
}
